import { render, staticRenderFns } from "./TituloContasPagar.vue?vue&type=template&id=2d856045&"
import script from "./TituloContasPagar.vue?vue&type=script&lang=js&"
export * from "./TituloContasPagar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports